@if(isAllStatePlan) {
<div class="flex flex-col gap-2 text-xs mx-2 my-3">

  <!-- Total row -->
  <div class="flex px-1.5 items-center justify-between font-semibold">
    <div class="font-semibold text-lg md:text-xl">{{lang.Total}}</div>
    <div class="text-end text-lg md:text-xl">
      <p class="text-end w-full outline-none">
        ${{ allFormData[addonKey]?.total || 0 | number : "1.2-2" }}
      </p>
    </div>
  </div>

  <div class="grid grid-cols-4 gap-2 lg:gap-4 items-center justify-between" *ngIf="isSinglePlan">
    <div class="col-span-3 flex gap-2 items-center">
      <input id="planCheckLife{{ addonKey }}-MEMBER-SINGLE"
        type="checkbox"
        attr.data="{{ pkg.name }}##{{ group.name }}##{{
          addonKey
        }}##{{
          plan.productAddonss[product][k].calculatedTax.price
        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
          plan.frqMonthly
        }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
          group.parentId
        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
          plan.packageId
        }}##0##{{ plan.planOptions }}##{{
          plan.productAddonss[product][k].id
        }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
        name="{{ addonKey }}-single"
        class="w-6 h-6 my-auto flex-shrink-0 rounded cursor-pointer"
        (change)="onCheckboxChangePLocal(
          $event,
          addonKey,
          'member',
          'coverage',
          plan.productAddonss[product][k],
          true
        )" />
      <label [htmlFor]="'planCheckLife' + addonKey + '-MEMBER'"
        class="mr-2 lg:mr-2 capitalize text-white w-full h-full label-text mt-3 text-[12px] font-semibold">
        {{ lang.SINGLE || 'SINGLE' }}
      </label>
    </div>
    <div class="col-span-1 text-white text-right font-semibold">
      <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none">
        ${{ allFormData[addonKey]?.member?.premium || 0 | number : "1.2-2" }}
      </p>
    </div>
  </div>


  
  <div class="grid grid-cols-4 gap-2 lg:gap-4 items-center justify-between" *ngIf="!isSinglePlan">
    <div class="col-span-3 flex gap-2 items-center">
      <input id="planCheckLife{{ addonKey }}-MEMBER-SINGLE"
        type="checkbox"
        attr.data="{{ pkg.name }}##{{ group.name }}##{{
          addonKey
        }}##{{
          plan.productAddonss[product][k].calculatedTax.price
        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
          plan.frqMonthly
        }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
          group.parentId
        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
          plan.packageId
        }}##0##{{ plan.planOptions }}##{{
          plan.productAddonss[product][k].id
        }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
        name="{{ addonKey }}-single"
        class="w-6 h-6 my-auto flex-shrink-0 rounded cursor-pointer"
        (change)="onCheckboxChangePLocal(
          $event,
          addonKey,
          'member',
          'coverage',
          plan.productAddonss[product][k],
          true
        )" />
      <label [htmlFor]="'planCheckLife' + addonKey + '-MEMBER'"
        class="mr-2 lg:mr-2 capitalize text-white w-full h-full label-text mt-3 text-[12px] font-semibold">
        {{  (lang.SINGLE || 'SINGLE') }}
      </label>
    </div>
    <div class="col-span-1 text-white text-right font-semibold">
      <!-- <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none">
        ${{ allFormData[addonKey]?.member?.premium || 0 | number : "1.2-2" }}
      </p> -->

      <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none" *ngIf="!showFamPrice">
        ${{ getDefaultPremium(addonKey, 'member', 'single') | number : "1.2-2" }}
      </p>
    </div>
  </div>

    <div class="grid grid-cols-4 gap-2 lg:gap-4 items-center justify-between" *ngIf="!isSinglePlan">
    <div class="col-span-3 flex gap-2 items-center">
      <input id="planCheckLife{{ addonKey }}-MEMBER-FAMILY"
        type="checkbox"
        attr.data="{{ pkg.name }}##{{ group.name }}##{{
          addonKey
        }}##{{
          plan.productAddonss[product][k].calculatedTax.price
        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
          plan.frqMonthly
        }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
          group.parentId
        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
          plan.packageId
        }}##0##{{ plan.planOptions }}##{{
          plan.productAddonss[product][k].id
        }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
        name="{{ addonKey }}-family"
        class="w-6 h-6 my-auto flex-shrink-0 rounded cursor-pointer"
        (change)="onCheckboxChangePLocal(
          $event,
          addonKey,
          'member',
          'coverage',
          plan.productAddonss[product][k],
          true
        )" />
      <label [htmlFor]="'planCheckLife' + addonKey + '-MEMBER'"
        class="mr-2 lg:mr-2 capitalize text-white w-full h-full label-text mt-3 text-[12px] font-semibold">
        {{ (lang.FAMILY || 'FAMILY') }}
      </label>
    </div>
    <div class="col-span-1 text-white text-right font-semibold">
      <!-- <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none">
        ${{ allFormData[addonKey]?.member?.premium || 0 | number : "1.2-2" }}
      </p> -->

      <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none" *ngIf="showFamPrice">
        ${{ getDefaultPremium(addonKey, 'member', 'family') | number : "1.2-2" }}
      </p>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-2">
    <div class="col-span-1 text-base md:text-xl mt-3 text-[12px] text-white">

      <p class="font-semibold mb-1 text-[11px] opacity-80" *ngIf="hasSpouse">
        {{ lang.MEMBER || 'Member' }}
      </p>
      <p>
     {{lang.In_the_past_12_months_have_you_used_any_form_of_tobacco_nicotine_products_or_substitutes_including_the_nicotine_patch_or_gum}}
      </p>

      <div class="grid grid-cols-3 mt-2">
        <!-- Yes -->
        <div class="flex justify-center items-center gap-2">
          <input type="radio"
            id="ci-member-{{ addonKey }}-yes"
            name="ci-member-{{ addonKey }}"
            class="w-6 h-6 my-auto outline-none cursor-pointer"
            attr.data="{{ pkg.name }}##{{ group.name }}##{{
              addonKey
            }}##{{
              plan.productAddonss[product][k].calculatedTax.price
            }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
              plan.frqMonthly
            }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
              group.parentId
            }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
              plan.packageId
            }}##0##{{ plan.planOptions }}##{{
              plan.productAddonss[product][k].id
            }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
            [disabled]="isDataAvailable(addonKey, 'member')"
            [checked]="allFormData[addonKey]?.member?.isSmoker === 'yes'"
            value="yes"
            (change)="onRadioChangeV2Local(
              $event,
              addonKey,
              'member',
              plan.planOptions,
              plan,
              plan.productAddonss[product][k],
              pkg,
              group,
              plan.productAddonss[product][k].member
            )" />
          <label [htmlFor]="'ci-member-' + addonKey + '-yes'"
            class="w-full mr-2 text-white text-[12px]">
            {{ lang.Yes }}
          </label>
        </div>
        <!-- No -->
        <div class="flex justify-center items-center gap-2">
          <input type="radio"
            id="ci-member-{{ addonKey }}-no"
            name="ci-member-{{ addonKey }}"
            class="w-6 h-6 my-auto outline-none cursor-pointer"
            attr.data="{{ pkg.name }}##{{ group.name }}##{{
              addonKey
            }}##{{
              plan.productAddonss[product][k].calculatedTax.price
            }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
              plan.frqMonthly
            }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
              group.parentId
            }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
              plan.packageId
            }}##0##{{ plan.planOptions }}##{{
              plan.productAddonss[product][k].id
            }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
            [disabled]="isDataAvailable(addonKey, 'member')"
            [checked]="allFormData[addonKey]?.member?.isSmoker === 'no'"
            value="no"
            (change)="onRadioChangeV2Local(
              $event,
              addonKey,
              'member',
              plan.planOptions,
              plan,
              plan.productAddonss[product][k],
              pkg,
              group,
              plan.productAddonss[product][k].member
            )" />
          <label [htmlFor]="'ci-member-' + addonKey + '-no'"
            class="w-full mr-2 text-white text-[12px]">
            {{ lang.No }}
          </label>
        </div>
      </div>

      <div *ngIf="hasSpouse" class="mt-4">
        <p class="font-semibold mb-1 text-[11px] opacity-80">
          {{ lang.SPOUSE || 'Spouse' }}
        </p>
        <p>
         {{lang.In_the_past_12_months_have_your_spouse_used_any_form_of_tobacco_nicotine_products_or_substitutes_including_the_nicotine_patch_or_gum}}
        </p>

        <div class="grid grid-cols-3 mt-2">
          <div class="flex justify-center items-center gap-2">
            <input type="radio"
              id="ci-spouse-{{ addonKey }}-yes"
              name="ci-spouse-{{ addonKey }}"
              class="w-6 h-6 my-auto outline-none cursor-pointer"
              attr.data="{{ pkg.name }}##{{ group.name }}##{{
                addonKey
              }}##{{
                plan.productAddonss[product][k].calculatedTax.price
              }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                plan.frqMonthly
              }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
                group.parentId
              }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                plan.packageId
              }}##0##{{ plan.planOptions }}##{{
                plan.productAddonss[product][k].id
              }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
              [disabled]="isDataAvailable(addonKey, 'member')"
              [checked]="allFormData[addonKey]?.member?.isSpouseSmoker === 'yes'"
              value="yes"
              (change)="onRadioChangeV2Local(
                $event,
                addonKey,
                'spouse',
                plan.planOptions,
                plan,
                plan.productAddonss[product][k],
                pkg,
                group,
                plan.productAddonss[product][k].member
              )" />
            <label [htmlFor]="'ci-spouse-' + addonKey + '-yes'"
              class="w-full mr-2 text-white text-[12px]">
              {{ lang.Yes }}
            </label>
          </div>
          <div class="flex justify-center items-center gap-2">
            <input type="radio"
              id="ci-spouse-{{ addonKey }}-no"
              name="ci-spouse-{{ addonKey }}"
              class="w-6 h-6 my-auto outline-none cursor-pointer"
              attr.data="{{ pkg.name }}##{{ group.name }}##{{
                addonKey
              }}##{{
                plan.productAddonss[product][k].calculatedTax.price
              }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                plan.frqMonthly
              }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
                group.parentId
              }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                plan.packageId
              }}##0##{{ plan.planOptions }}##{{
                plan.productAddonss[product][k].id
              }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
              [disabled]="isDataAvailable(addonKey, 'member')"
              [checked]="allFormData[addonKey]?.member?.isSpouseSmoker === 'no'"
              value="no"
              (change)="onRadioChangeV2Local(
                $event,
                addonKey,
                'spouse',
                plan.planOptions,
                plan,
                plan.productAddonss[product][k],
                pkg,
                group,
                plan.productAddonss[product][k].member
              )" />
            <label [htmlFor]="'ci-spouse-' + addonKey + '-no'"
              class="w-full mr-2 text-white text-[12px]">
              {{ lang.No }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <p style="font-size: 10px; color: white;">Note: If any one in the family smokes then we need to charge the smoker price for whole family.</p>


    <div class="">
      <div>
        <p class="block my-3 text-center font-semibold mb-2 text-[12px] text-white">
          ${{ plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence / 1000 | number }}k
        </p>
        <div>
          <!-- Tick marks: only first and last -->
          <div *ngIf="
            plan.productAddonss[product][k].member.maximumCoverageWithEvidence &&
            plan.productAddonss[product][k].member.minimumCoverage
          " class="range-ticks flex justify-between mt-2">
            <ng-container *ngFor="
              let tick of generateTicks(
                plan.productAddonss[product][k].member.maximumCoverageWithEvidence,
                plan.productAddonss[product][k].member.minimumCoverage
              );
              let i = index; let last = last
            ">
              <span *ngIf="i === 0 || last" class="tick" [ngStyle]="{
                position: 'absolute',
                left: i === 0 ? '0.4%' : '99.6%',
                top: '9px',
                width: '2px',
                height: '6px',
                backgroundColor: 'white'
              }"></span>
            </ng-container>
          </div>



          <div class="range-slider-container">
            <div class="range-slider-wrapper">
              <input type="range"
                attr.data="{{ pkg.name }}##{{ group.name }}##{{
                  addonKey
                }}##{{
                  plan.productAddonss[product][k].calculatedTax.price
                }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                  plan.frqMonthly
                }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
                  group.parentId
                }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                  plan.packageId
                }}##0##{{ plan.planOptions }}##{{
                  plan.productAddonss[product][k].id
                }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
                id="{{ addonKey }}-ci-rangeSlider"
                name="{{ addonKey }}-ci-rangeSlider"
                [(ngModel)]="plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="isDataAvailableAllState(addonKey, 'member', 'isSmoker')"
                (change)="onRangeChangeV2Local(
                  $event,
                  addonKey,
                  'member',
                  plan.planOptions,
                  plan,
                  plan.productAddonss[product][k],
                  pkg,
                  group,
                  $event,
                  plan.productAddonss[product][k].member
                )"
                [min]="0"
                [max]="plan.productAddonss[product][k].member.maximumCoverageWithEvidence"
                [step]="plan.productAddonss[product][k].member.minimumCoverage"
                [ngStyle]="{
                  background: getSliderBackground(
                    plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence,
                    plan.productAddonss[product][k].member.maximumCoverageWithEvidence,
                    plan.productAddonss[product][k].member.minimumCoverage,
                    plan.productAddonss[product][k].member.defaultRange
                  )
                }"
                class="my-2 border appearance-none w-full h-4 rounded-md focus:outline-none" />

              <p class="name-label leading-4 text-[10px]" [ngStyle]="{ 'width.%': greenValue }">
                {{ lang.Guaranteed_Approval }}
              </p>
              <!-- @if (showyellowbar) {
                <p class="name-label leading-4 text-[10px]"
                   [ngStyle]="{ 'right.%': 0 }" style="top:-10px">
                  {{ lang.Pending_Approval }}
                </p>
              } -->

             <div class="range-ticks1">
                <ng-container *ngFor="let val of allStateRangeValues; let i = index">
                  <span class="tick1"></span>
                </ng-container>
              </div>
            </div>

           <!-- Labels below ticks -->
            <div class="range-labels" style="display: flex; justify-content: space-between; margin-top: 4px;">
              <ng-container *ngFor="let val of allStateRangeValues; let i = index">
                <span class="range-label text-white text-[10px]">
                  ${{ val / 1000 | number:'1.0-0' }}k
                </span>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  </div>

</div>
}


@if(!isAllStatePlan) {
<div class="flex flex-col gap-2 text-xs mx-2 my-3">

  <div class="flex px-1.5 items-center justify-between font-semibold">
    <div class="font-semibold text-lg md:text-xl">{{lang.Total}}</div>
    <div class="text-end text-lg md:text-xl">
      <p class="text-end w-full outline-none">
        ${{ allFormData[addonKey]?.total || 0 | number : "1.2-2" }}
      </p>
    </div>
  </div>

  <div class="grid grid-cols-4 gap-2 lg:gap-4 items-center justify-between">
    <div class="col-span-3 flex gap-2 items-center">
      <input id="planCheckLife{{ addonKey }}-MEMBER"
        type="checkbox"
        attr.data="{{ pkg.name }}##{{ group.name }}##{{
          addonKey
        }}##{{
          plan.productAddonss[product][k].calculatedTax.price
        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
          plan.frqMonthly
        }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
          group.parentId
        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
          plan.packageId
        }}##0##{{ plan.planOptions }}##{{
          plan.productAddonss[product][k].id
        }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
        name="{{ addonKey }}-member"
        class="w-6 h-6 my-auto flex-shrink-0 rounded cursor-pointer"
        (change)="onCheckboxChangePLocal(
          $event,
          addonKey,
          'member',
          'coverage',
          plan.productAddonss[product][k]
        )" />
      <label [htmlFor]="'planCheckLife' + addonKey + '-MEMBER'"
        class="mr-2 lg:mr-2 capitalize text-white w-full h-full label-text mt-3 text-[12px]">
        {{ lang.MEMBER }}
      </label>
    </div>
    <div class="col-span-1 text-white text-right font-semibold">
      <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none">
        ${{ allFormData[addonKey]?.member?.premium || 0 | number : "1.2-2" }}
      </p>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-2">
    <div class="col-span-1 text-base md:text-xl mt-3 text-[12px] text-white">
      <p>
        In the last 12 months, have you used, in any form whatsoever, tobacco,
        nicotine or cannabis mixed with tobacco?
      </p>

      <div class="grid grid-cols-3 mt-2">
        <!-- Yes -->
        <div class="flex justify-center items-center gap-2">
          <input type="radio"
            class="member-{{ addonKey }}-yes w-6 h-6 my-auto outline-none cursor-pointer"
            id="member-{{ addonKey }}-yes"
            name="member-{{ addonKey }}"
            attr.data="{{ pkg.name }}##{{ group.name }}##{{
              addonKey
            }}##{{
              plan.productAddonss[product][k].calculatedTax.price
            }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
              plan.frqMonthly
            }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
              group.parentId
            }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
              plan.packageId
            }}##0##{{ plan.planOptions }}##{{
              plan.productAddonss[product][k].id
            }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
            [disabled]="isDataAvailable(addonKey, 'member')"
            [checked]="
              allFormData[addonKey] &&
              allFormData[addonKey]['member'] &&
              allFormData[addonKey]['member']['isSmoker'] === 'yes'
            "
            value="yes"
            (change)="onRadioChangeLocal(
              $event,
              addonKey,
              'member',
              plan.planOptions,
              plan,
              plan.productAddonss[product][k],
              pkg,
              group,
              plan.productAddonss[product][k].member
            )" />
          <label [htmlFor]="'member-' + addonKey + '-yes'"
            class="w-full mr-2 text-white text-[12px]">
            {{ lang.Yes }}
          </label>
        </div>
        <div class="flex justify-center items-center gap-2">
          <input type="radio"
            class="member-{{ addonKey }}-no w-6 h-6 my-auto outline-none cursor-pointer"
            id="member-{{ addonKey }}-no"
            name="member-{{ addonKey }}"
            attr.data="{{ pkg.name }}##{{ group.name }}##{{
              addonKey
            }}##{{
              plan.productAddonss[product][k].calculatedTax.price
            }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
              plan.frqMonthly
            }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
              group.parentId
            }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
              plan.packageId
            }}##0##{{ plan.planOptions }}##{{
              plan.productAddonss[product][k].id
            }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
            [disabled]="isDataAvailable(addonKey, 'member')"
            [checked]="
              allFormData[addonKey] &&
              allFormData[addonKey]['member'] &&
              allFormData[addonKey]['member']['isSmoker'] === 'no'
            "
            value="no"
            (change)="onRadioChangeLocal(
              $event,
              addonKey,
              'member',
              plan.planOptions,
              plan,
              plan.productAddonss[product][k],
              pkg,
              group,
              plan.productAddonss[product][k].member
            )" />
          <label [htmlFor]="'member-' + addonKey + '-no'"
            class="w-full mr-2 text-white text-[12px]">
            {{ lang.No }}
          </label>
        </div>
      </div>
    </div>

    <!-- Member range slider -->
    <div class="">
      <div>
        <p class="block my-3 text-center font-semibold mb-2 text-[12px]">
          ${{ plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence / 1000 | number }}k
        </p>
        <div>
          <div *ngIf="
            plan.productAddonss[product][k].member.maximumCoverageWithEvidence &&
            plan.productAddonss[product][k].member.minimumCoverage
          " class="range-ticks flex justify-between mt-2">
            <ng-container *ngFor="
              let tick of generateTicks(
                plan.productAddonss[product][k].member.maximumCoverageWithEvidence,
                plan.productAddonss[product][k].member.minimumCoverage
              );
              let i = index;
              let last = last
            ">
              <span *ngIf="i === 0 || last" class="tick" [ngStyle]="{
                position: 'absolute',
                left: i === 0 ? '0.4%' : '99.6%',
                top: '9px',
                width: '2px',
                height: '6px',
                backgroundColor: 'white'
              }"></span>
            </ng-container>
          </div>

          <div class="range-slider-container">
            <div class="range-slider-wrapper">
              <!-- Slider input -->
              <input type="range"
                attr.data="{{ pkg.name }}##{{ group.name }}##{{
                  addonKey
                }}##{{
                  plan.productAddonss[product][k].calculatedTax.price
                }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                  plan.frqMonthly
                }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
                  group.parentId
                }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                  plan.packageId
                }}##0##{{ plan.planOptions }}##{{
                  plan.productAddonss[product][k].id
                }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
                [disabled]="isDataAvailable(addonKey, 'member', 'isSmoker')"

                id="{{ addonKey }}-member-rangeSlider"
                name="{{ addonKey }}-member-rangeSlider"
                [(ngModel)]="plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence"
                [ngModelOptions]="{ standalone: true }"
                (change)="onRangeChangeLocal(
                  $event,
                  addonKey,
                  'member',
                  plan.planOptions,
                  plan,
                  plan.productAddonss[product][k],
                  pkg,
                  group,
                  $event,
                  plan.productAddonss[product][k].member
                )"
                [min]="0"
               [max]="plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence"
                [step]="plan.productAddonss[product][k].member.minimumCoverage"
                [ngStyle]="{
                  background: getSliderBackground(
                    plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence,
                    plan.productAddonss[product][k].member.maximumCoverageWithEvidence,
                    plan.productAddonss[product][k].member.minimumCoverage,
                    plan.productAddonss[product][k].member.defaultRange
                  )
                }"
                class="my-2 border appearance-none w-full h-4 rounded-md focus:outline-none" />

              <!-- Guaranteed label -->
              <p class="name-label leading-4 text-[10px]" [ngStyle]="{ 'width.%': greenValue }">
                {{ lang.Guaranteed_Approval }}
              </p>
              @if (showyellowbar) {
                <p class="name-label leading-4 text-[10px]"
                   [ngStyle]="{ 'right.%': 0 }" style="top:-10px">
                  {{ lang.Pending_Approval }}
                </p>
              }


              <div class="range-ticks1">
                <ng-container *ngFor="let val of rangeValues; let i = index; let last = last">
                  <span *ngIf="i === 0 || last || val % 1000 === 0" class="tick1"></span>
                </ng-container>
              </div>
            </div>

            <div class="range-labels">
              <ng-container *ngFor="let val of rangeValues; let i = index; let last = last">
                <span *ngIf="i === 0 || last || val % 1000 === 0" class="range-label">
                  ${{ val / 1000 | number:'1.0-0' }}k
                </span>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  </div>
</div>


<div class="flex flex-col gap-2 text-xs mx-2 my-3"
  *ngIf="userForm.get('having_spouse')?.value === 'true'">

  <div class="grid grid-cols-4 gap-2 lg:gap-4 items-center justify-between">
    <div class="col-span-3 flex gap-2 items-center">
      <input id="planCheckLife{{ addonKey }}-SPOUSE"
        type="checkbox"
        attr.data="{{ pkg.name }}##{{ group.name }}##{{
          addonKey
        }}##{{
          plan.productAddonss[product][k].calculatedTax.price
        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
          plan.frqMonthly
        }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
          group.parentId
        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
          plan.packageId
        }}##0##{{ plan.planOptions }}##{{
          plan.productAddonss[product][k].id
        }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
        name="{{ addonKey }}-spouse"
        class="w-6 h-6 my-auto flex-shrink-0 rounded cursor-pointer"
        [disabled]="isDataAvailableSpouse(addonKey, 'member')"
        (change)="onCheckboxChangePLocal(
          $event,
          addonKey,
          'spouse',
          'coverage',
          plan.productAddonss[product][k]
        )" />
      <label [htmlFor]="'planCheckLife' + addonKey + '-SPOUSE'"
        class="mr-2 lg:mr-2 font-bold capitalize text-white w-full h-full label-text text-[12px] mt-3">
        {{ lang.SPOUSE }}
      </label>
    </div>
    <div class="col-span-1 text-white text-right font-semibold">
      <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none">
        ${{ allFormData[addonKey]?.spouse?.premium || 0 | number : "1.2-2" }}
      </p>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-2">
    <div class="col-span-1 text-base md:text-xl mt-3 text-[12px] text-white">
      <p>
        In the last 12 months, have you used, in any form whatsoever, tobacco,
        nicotine or cannabis mixed with tobacco?
      </p>

      <div class="grid grid-cols-3 mt-2">
        <!-- Yes -->
        <div class="flex justify-center items-center gap-2">
          <input type="radio"
            class="spouse-{{ addonKey }}-yes w-6 h-6 my-auto outline-none cursor-pointer"
            id="spouse-{{ addonKey }}-yes"
            name="spouse-{{ addonKey }}"
            attr.data="{{ pkg.name }}##{{ group.name }}##{{
              addonKey
            }}##{{
              plan.productAddonss[product][k].calculatedTax.price
            }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
              plan.frqMonthly
            }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
              group.parentId
            }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
              plan.packageId
            }}##0##{{ plan.planOptions }}##{{
              plan.productAddonss[product][k].id
            }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
            [disabled]="isDataAvailableSpouseDataa(addonKey, 'spouse')"
            value="yes"
            [checked]="
              allFormData[addonKey] &&
              allFormData[addonKey]['spouse'] &&
              allFormData[addonKey]['spouse']['isSpouseSmoker'] === 'yes'
            "
            (change)="onRadioChangeLocal(
              $event,
              addonKey,
              'spouse',
              plan.planOptions,
              plan,
              plan.productAddonss[product][k],
              pkg,
              group,
              plan.productAddonss[product][k].spouse
            )" />
          <label [htmlFor]="'spouse-' + addonKey + '-yes'"
            class="w-full mr-2 text-white text-[12px]">
            {{ lang.Yes }}
          </label>
        </div>
        <!-- No -->
        <div class="flex justify-center items-center gap-2">
          <input type="radio"
            class="spouse-{{ addonKey }}-no w-6 h-6 my-auto outline-none cursor-pointer"
            id="spouse-{{ addonKey }}-no"
            name="spouse-{{ addonKey }}"
            attr.data="{{ pkg.name }}##{{ group.name }}##{{
              addonKey
            }}##{{
              plan.productAddonss[product][k].calculatedTax.price
            }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
              plan.frqMonthly
            }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
              group.parentId
            }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
              plan.packageId
            }}##0##{{ plan.planOptions }}##{{
              plan.productAddonss[product][k].id
            }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
            [disabled]="isDataAvailableSpouseDataa(addonKey, 'spouse')"
            value="no"
            [checked]="
              allFormData[addonKey] &&
              allFormData[addonKey]['spouse'] &&
              allFormData[addonKey]['spouse']['isSpouseSmoker'] === 'no'
            "
            (change)="onRadioChangeLocal(
              $event,
              addonKey,
              'spouse',
              plan.planOptions,
              plan,
              plan.productAddonss[product][k],
              pkg,
              group,
              plan.productAddonss[product][k].spouse
            )" />
          <label [htmlFor]="'spouse-' + addonKey + '-no'"
            class="w-full mr-2 text-white text-[12px]">
            {{ lang.No }}
          </label>
        </div>
      </div>
    </div>

    <div class="">
      <div>
        <p class="block my-3 text-center mb-2 font-semibold text-[12px]">
          ${{ plan.productAddonss[product][k].spouse.maximumCoverageWithoutEvidence / 1000 | number }}k
        </p>
        <div>
          <div *ngIf="
            plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence &&
            plan.productAddonss[product][k].spouse.minimumCoverage
          " class="range-ticks flex justify-between mt-2">
            <ng-container *ngFor="
              let tick of generateTicks(
                plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence,
                plan.productAddonss[product][k].spouse.minimumCoverage
              );
              let i = index;
              let last = last
            ">
              <span *ngIf="i === 0 || last" class="tick" [ngStyle]="{
                position: 'absolute',
                left: i === 0 ? '0.4%' : '99.5%',
                top: '9px',
                width: '2px',
                height: '6px',
                backgroundColor: 'white'
              }"></span>
            </ng-container>
          </div>

          <div class="range-slider-container">
            <div class="range-slider-wrapper">
              <input type="range"
                class="spouse-{{ addonKey }}-no"
                attr.data="{{ pkg.name }}##{{ group.name }}##{{
                  addonKey
                }}##{{
                  plan.productAddonss[product][k].calculatedTax.price
                }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                  plan.frqMonthly
                }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
                  group.parentId
                }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                  plan.packageId
                }}##0##{{ plan.planOptions }}##{{
                  plan.productAddonss[product][k].id
                }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
                [disabled]="isDataAvailable(addonKey, 'spouse', 'isSmoker')"
                id="{{ addonKey }}-spouse-rangeSlider"
                name="{{ addonKey }}-spouse-rangeSlider"
                [(ngModel)]="plan.productAddonss[product][k].spouse.maximumCoverageWithoutEvidence"
                [ngModelOptions]="{ standalone: true }"
                (change)="onRangeChangeLocal(
                  $event,
                  addonKey,
                  'spouse',
                  plan.planOptions,
                  plan,
                  plan.productAddonss[product][k],
                  pkg,
                  group,
                  $event,
                  plan.productAddonss[product][k].spouse
                )"
                [min]="0"
                [max]="plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence"
                [step]="plan.productAddonss[product][k].spouse.minimumCoverage"
                [ngStyle]="{
                  background: getSliderBackground(
                    plan.productAddonss[product][k].spouse.maximumCoverageWithoutEvidence,
                    plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence,
                    plan.productAddonss[product][k].spouse.minimumCoverage,
                    plan.productAddonss[product][k].member.defaultRange
                  )
                }"
                class="my-2 border appearance-none w-full h-4 rounded-md focus:outline-none"
                style="background: #78aaef" />

              <p class="name-label leading-4 text-[10px]" [ngStyle]="{ 'width.%': greenValue }">
                {{ lang.Guaranteed_Approval }}
              </p>
              @if (showyellowbar) {
                <p class="name-label leading-4 text-[10px]"
                   [ngStyle]="{ 'right.%': 0 }" style="top:-10px">
                  {{ lang.Pending_Approval }}
                </p>
              }

              <div class="range-ticks1">
                <ng-container *ngFor="let val of rangeValues; let i = index; let last = last">
                  <span *ngIf="i === 0 || last || val % 1000 === 0" class="tick1"></span>
                </ng-container>
              </div>
            </div>

            <div class="range-labels">
              <ng-container *ngFor="let val of rangeValues; let i = index; let last = last">
                <span *ngIf="i === 0 || last || val % 1000 === 0" class="range-label">
                  ${{ val / 1000 | number:'1.0-0' }}k
                </span>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
